import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
// import Chat from "../../../../component/common/chat";
import ScrollHeader from "../headerNote";
import WebNavbar from "../navbar";
import HeroSection  from "../../views/home/Banner/FullWidthBanner"
import BannerContent from "../../views/home/Banner/bannercontent"
import WebFooter from "../footer";
import AboutImporterr from "../aboutImporterr";
import ContactBanner from "../../views/home/contactUs";
import ErrorBoundary from "../../../../component/common/ErrorBoundary";
import SimilarSearchProgress from "../../common/SimilarSearchProgress";
import "../../../assets/colors/index.css";
import "../../../assets/fonts/index.css";
import "./style.css";

export default function WebLayout({ children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isHomePage = location.pathname === "/";  // ✅ Check current route

  return (
    <div className="web_layout_bg">
      <ScrollHeader />
      <WebNavbar />
      {isHomePage && <HeroSection />}   {/*  Show only on homepage */}
      {isHomePage && <BannerContent />}
      <div className="web_layout_children">
        <div className="web_layout_children_content">
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
      </div>

      {/* {isHomePage && <ContactBanner />}   ✅ Show only on homepage */}

      <WebFooter />
      <AboutImporterr />
      
      {/* Global progress overlay for Find Similar feature */}
      <SimilarSearchProgress />
    </div>
  );
}
